import React from 'react';
export function Footer() {
  return <footer className="w-full bg-cocoa px-5 py-16 text-cream sm:px-8" data-id="element-26" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl text-center" data-id="element-27" data-mp="3ggar7wn6mf5z">
        <p className="font-serif text-3xl leading-snug italic text-sand sm:text-4xl" data-id="element-28" data-mp="3gh3n22klrk9c">
          Porque tu paz también importa.
          <br data-id="element-29" data-mp="36oy05797jt10" />
          Tu tiempo también importa.
          <br data-id="element-30" data-mp="36nd4feb5q41k" />
          Y tú mereces vivir con más calma.
        </p>
        <p className="mt-12 text-xs uppercase tracking-[0.2em] text-sand/60" data-id="element-31" data-mp="3ugbsveb9tqmi">
          Organiza Tu Vida en 7 Días · Ebook en español
        </p>
      </div>
    </footer>;
}